export const loadScript = (parent: Element, attributes: any) => {
  const script = document.createElement('script');
  Object.getOwnPropertyNames(attributes).forEach((attr) =>
    script.setAttribute(attr, attributes[attr])
  );
  script.innerHTML = '';
  script.type = 'text/javascript';
  parent.appendChild(script);
};
